import React, { useEffect, useState } from 'react'

const ChatInput = ({
    variant = 'chat',
    placeholder = 'Type here...',
    buttonLabel = 'Send',
    initialValue = '',
    onSubmit,
}) => {
    const [value, setValue] = useState(initialValue)

    useEffect(() => {
        setValue(initialValue)
    }, [initialValue])

    const submitTrimmedValue = () => {
        const trimmed = value.trim()
        if (!trimmed) return
        onSubmit(trimmed)
        setValue('')
    }

    const submitOnEnter = (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault()
            submitTrimmedValue()
        }
    }

    const preventDefaultThenSubmit = (event) => {
        event.preventDefault()
        submitTrimmedValue()
    }

    if (variant === 'url') {
        return (
            <form className='chat-input is-url' onSubmit={preventDefaultThenSubmit}>
                <input
                    type='text'
                    value={value}
                    onChange={(event) => setValue(event.target.value)}
                    placeholder={placeholder}
                />
                <button type='submit' className='action-btn' disabled={!value.trim()}>
                    {buttonLabel}
                </button>
            </form>
        )
    }

    return (
        <form className='chat-input' onSubmit={preventDefaultThenSubmit}>
            <textarea
                value={value}
                onChange={(event) => setValue(event.target.value)}
                onKeyDown={submitOnEnter}
                placeholder={placeholder}
                rows={3}
            />
            <button
                type='submit'
                className='send-btn'
                disabled={!value.trim()}
                aria-label='Send'
            >
                <svg width='16' height='16' viewBox='0 0 24 24' fill='none' aria-hidden='true'>
                    <path
                        d='M12 19V5M5 12l7-7 7 7'
                        stroke='currentColor'
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </svg>
            </button>
        </form>
    )
}

export default ChatInput
